import axios from "axios";
import ApiCall from "../constants/Api";

export const helpAxios = (endpoint, options, session, svc) => {
  if (endpoint === ApiCall.PING || endpoint === ApiCall.PING_LEGACY) {
    return axios
      .get(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return { error: err };
      });
  }

  if (
    endpoint === ApiCall.LOGIN ||
    endpoint === ApiCall.LOGOUT ||
    endpoint === ApiCall.GET_MY_IP ||
    endpoint === ApiCall.ONLINE_RESET_USER_PASSWORD ||
    endpoint === ApiCall.INVOKE_GET_METHOD
  ) {
    return axios
      .post(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, options, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.data.OutParams.Result !== 0) {
            return {
              error: response.data.OutParams.ErrMsg,
              Result: response.data.OutParams.Result,
              data: response.data,
            };
          } else {
            return response.data;
          }
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  } else {
    let request = {
      ServiceName: svc,
      MethodName: endpoint,
      Json: options,
    };
    return axios
      .post(
        window.config.SiteConfig.PROXYSEC_SVC + "/" + ApiCall.INVOKE_METHOD,
        request,
        {
          headers: {
            "X-SESSIONID": session,
          },
        },
      )
      .then((response) => {
        if (response.data) {
          const res = response.data;

          if (res.OutParams.Result !== 0) {
            return {
              error: res.OutParams.ErrMsg,
              Result: res.OutParams.Result,
            };
          }

          const json = res.Json || {};
          const result =
            typeof json.Result !== "undefined"
              ? json.Result
              : json.OutParams?.Result;

          if (result !== 0) {
            return {
              error: json.ErrMsg || json.OutParams?.ErrMsg || "Unknown error",
              Result: result,
            };
          }

          return json;
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  }
};
